// Browser OAuth returns its one-time exchange token in the URL fragment. Keep
// this parser deliberately strict: sponsor/link-shortener providers may append
// generic query parameters such as `?token=...` when they return to Harday,
// and those values are not authentication credentials.
export const getGoogleLoginTokenFromLocation = (location) => {
  try {
    const hash = location?.hash || '';
    if (!hash.includes('google_login_token=')) return null;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    return params.get('google_login_token');
  } catch {
    return null;
  }
};

// A stored session should only be removed when the API has actually rejected
// it. Network errors, timeouts, and server failures do not prove that a signed
// token is invalid and are especially likely after a long external redirect.
export const isAuthRejection = (error) => Number(error?.response?.status) === 401;
